module.exports = __webpack_public_path__ + "img/global-tx-type.a63b4aad.svg";